/**
 * Created by zhoulong on 2019/6/24.
 */

const httpStatus = {
    OK: 200,
    ERROR: 500,
    // 未鉴权
    INVALID_TOKEN: 401,
    // 无权限
    FORBIDDEN: 403
}

export default httpStatus
